import { defineMessages } from 'react-intl';

export * from './aps/externals';

export const ActionTypes = Object.freeze({
  NOOP: 'NOOP',
  SET_PLAYLIST: 'SET_PLAYLIST',
  INSERT_TRACK_INTO_PLAYLIST: 'INSERT_TRACK_INTO_PLAYLIST',

  PLAYBACK_TRACK_ENDED: 'PLAYBACK_TRACK_ENDED',
  PLAY_NEXT_TRACK: 'PLAY_NEXT_TRACK',
  INTENT_PLAY_TRACK: 'INTENT_PLAY_TRACK',
  STATION_TRACK_RESUMED_FROM_SOURCE: 'STATION_TRACK_RESUMED_FROM_SOURCE',

  START_STATION_FAIL: 'START_STATION_FAIL',
  STATION_CREATED: 'STATION_CREATED',
  LOAD_STATIONS: 'LOAD_STATIONS',
  PLAY_STATION: 'PLAY_STATION',
  CREATE_STATION: 'CREATE_STATION',
  ROUTE_TO_STATION_DETAILS_FROM_FACTORY_ID: 'ROUTE_TO_STATION_DETAILS_FROM_FACTORY_ID',
  REQUEST_PLAY_TRACK: 'REQUEST_PLAY_TRACK',
  CLICKED_PLAY: 'CLICKED_PLAY', // User explicitly clicked the play button in the tuner
  CLICKED_VIDEO_PLAY: 'CLICKED_VIDEO_PLAY', // User explicitly clicked the play button of the video ad overlay
  XTAB_PLAY: 'XTAB_PLAY', // XTAB_PLAY to communicate to other tabs the intent to play track on this tab
  XTAB_PAUSED: 'XTAB_PAUSED', // XTAB_PAUSED to communicate to other tabs that the audio stream has paused on this tab
  CLICKED_PAUSE: 'CLICKED_PAUSE', // User explicitly clicked the pause button in the tuner
  CLICKED_VIDEO_PAUSE: 'CLICKED_VIDEO_PAUSE', // User explicitly clicked the pause button of the video ad overlay
  REPLAY_TRACK: 'REPLAY_TRACK',
  REPLAY_TRACK_SUCCESS: 'REPLAY_TRACK_SUCCESS',
  TRACK_THUMBUP: 'TRACK_THUMBUP',
  TRACK_THUMBDOWN: 'TRACK_THUMBDOWN',
  TRACK_REMOVE_THUMBUP: 'TRACK_REMOVE_THUMBUP',
  TRACK_REMOVE_THUMBDOWN: 'TRACK_REMOVE_THUMBDOWN',
  TIRE_OF_TRACK: 'TIRE_OF_TRACK',
  VOLUME_SET: 'VOLUME_SET',
  START_REMOVE_STATION_FLOW: 'START_REMOVE_STATION_FLOW',
  REMOVE_STATION: 'REMOVE_STATION',
  UNDO_REMOVE_STATION: 'UNDO_REMOVE_STATION',
  CONFIRM_REMOVE_STATION: 'CONFIRM_REMOVE_STATION',
  SET_IS_IN_STATION_SHUFFLE_MODE: 'SET_IS_IN_STATION_SHUFFLE_MODE',
  TOGGLE_SHUFFLE_ALL_STATIONS_MODE: 'TOGGLE_SHUFFLE_ALL_STATIONS_MODE',
  SET_STATION_TO_BE_REMOVED_FROM_SERVER: 'SET_STATION_TO_BE_REMOVED_FROM_SERVER',
  CLEAR_STATION_TO_BE_REMOVED_FROM_SERVER: 'CLEAR_STATION_TO_BE_REMOVED_FROM_SERVER',
  ADD_TRACK_TO_STATION_HISTORY: 'ADD_TRACK_TO_STATION_HISTORY',
  SET_STATION_RECEIVED_FRAGMENT: 'SET_STATION_RECEIVED_FRAGMENT',

  IS_STATION_NARRATIVE_DISPLAYED: 'IS_STATION_NARRATIVE_DISPLAYED',
  GET_TRACK_NARRATIVE_FAIL: 'GET_TRACK_NARRATIVE_FAIL',

  RELOAD_AUDIOPLAYBACK: 'RELOAD_AUDIOPLAYBACK',
  RESET_GET_NEXT_TRACK_ERROR: 'RESET_GET_NEXT_TRACK_ERROR',

  REMOVE_STATION_FROM_SHUFFLE_LIST: 'REMOVE_STATION_FROM_SHUFFLE_LIST',
  ADD_STATION_TO_SHUFFLE_LIST: 'ADD_STATION_TO_SHUFFLE_LIST',

  REMOVE_ARTIST_AUDIO_MESSAGES_FROM_PLAYLIST: 'REMOVE_ARTIST_AUDIO_MESSAGES_FROM_PLAYLIST',
  CLICKED_ARTIST_AUDIO_MESSAGE: 'CLICKED_ARTIST_AUDIO_MESSAGE',
  CLICKED_VOICE_TRACK: 'CLICKED_VOICE_TRACK',
  TRIGGERED_ARTIST_AUDIO_MESSAGE_TILE: 'TRIGGERED_ARTIST_AUDIO_MESSAGE_TILE',
  TRIGGERED_VOICE_TRACK_TILE: 'TRIGGERED_VOICE_TRACK_TILE',

  ADD_ALL_ELIGIBLE_STATIONS_TO_SHUFFLE: 'ADD_ALL_ELIGIBLE_STATIONS_TO_SHUFFLE',
  RESTORE_PREVIOUS_SHUFFLE_CONFIG: 'RESTORE_PREVIOUS_SHUFFLE_CONFIG',

  LOG_DRM_RECEIPT: 'LOG_DRM_RECEIPT',
  LOG_SKIP_FOR_DRM: 'LOG_SKIP_FOR_DRM',
  TRACK_COMPLETE_AUDIO_ANALYTICS: 'TRACK_COMPLETE_AUDIO_ANALYTICS',
  RESET_PLAYLIST_INDEX: 'RESET_PLAYLIST_INDEX',
  REGISTER_ARTIST_MESSAGE_METRIC: 'REGISTER_ARTIST_MESSAGE_METRIC',
  REGISTER_VOICE_TRACK_METRIC: 'REGISTER_VOICE_TRACK_METRIC',
  REGISTER_SKIP_TRACK: 'REGISTER_SKIP_TRACK',
  SET_OR_CREATE_STATION: 'SET_OR_CREATE_STATION',
  SET_OR_CREATE_STATION_FINISHED: 'SET_OR_CREATE_STATION_FINISHED',
  PLAYBACK_LOG_TRACK_STARTED: 'PLAYBACK_LOG_TRACK_STARTED',
  PLAYBACK_LOG_TRACK_RESUMED: 'PLAYBACK_LOG_TRACK_RESUMED',
  PLAYBACK_LOG_START_PLAYING: 'PLAYBACK_LOG_START_PLAYING',
});

export const SESSION_HISTORY_LIMIT = 30;

export const IS_REPLAYED_TRACK = 'IS_REPLAYED_TRACK';

export const ExternalMessages = defineMessages({
  replayNotAvailableLicensing: {
    id: 't.replayNotAvailable',
    defaultMessage: 'This song can’t currently be replayed.',
  },
});

export const PLAYBACK_CONTROLS = Object.freeze({
  PLAY: 'play',
  SKIP: 'SKIP',
  REPLAY: 'REPLAY',
  VOLUME: 'volume',
  THUMBS: 'THUMB',
  REPEAT: 'repeat',
  SHUFFLE: 'shuffle',
  SKIP_BACK: 'skipBack',
  SKIP_15_BACK: 'BACK_15_SECONDS',
  SKIP_FORWARD: 'skipForward',
  SKIP_15_FORWARD: 'FORWARD_15_SECONDS',
  SCRUB: 'SEEK',
  REPLAY_REWARD: 'REPLAY_REWARD',
  SKIP_REWARD: 'SKIP_REWARD',
});

export const PlaybackErrors = Object.freeze({
  MARKING_TRACK_AS_TIRED_IN_PROGRESS: 'MARKING_TRACK_AS_TIRED_IN_PROGRESS',
  UPDATING_FEEDBACK_IN_PROGRESS: 'UPDATING_FEEDBACK_IN_PROGRESS',
  GET_REPLAY_TRACK_FAILED: 'GET_REPLAY_TRACK_FAILED',
  INVALID_TRACK: 'INVALID_TRACK',
  INVALID_ARGUMENTS: 'INVALID_ARGUMENTS',
  GENERAL_PLAYBACK_ERROR: 'GENERAL_PLAYBACK_ERROR',
  NO_RIGHTS: 'FLEX_ON_DEMAND_RIGHT_UNAVAILABLE',
});

export const PlaybackMessages = defineMessages({
  thumbprintRadioIneligible: {
    id: 't.thumbprintRadioIneligible',
    defaultMessage:
      "Want Thumbprint Radio? We need to know you a little better. Keep creating stations and thumbing up songs you love, and we'll let you know when it's ready!",
  },
});

export const DRMSkipReasons = Object.freeze({
  COMPLETE: 0,
  SKIP: 1,
  STATION_CHANGE: 2,
  THUMBED_DOWN: 3,
  ERROR: 4,
  DISCARDED: 5,
  EXPIRED: 6,
  UNKNOWN: 7,
  REPLAY: 8,
});

export const FragmentRequestReasons = Object.freeze({
  SKIP: 'Skip',
  NORMAL: 'Normal',
  THUMBED_DOWN: 'ThumbDown',
  CHANGE_MODE: 'changeMode',
});
